import { autoinject, useView } from 'aurelia-framework';
import { MdcDialog } from '@aurelia-mdc-web/dialog';
import { UserLookupViewModel } from '@dynamik/common/clients/policy-clients';

@autoinject
@useView('./assign-user-dialog.html')
export class AssignUserDialog {
  constructor(private dialog: MdcDialog) { }

  model: { users: UserLookupViewModel[], selectedId: number };

  activate(model: { users: UserLookupViewModel[], selectedId: number }) {
    this.model = model;
  }

  getOptions = (filter: string, value: number): Promise<UserLookupViewModel[]> => {
    if (value) {
        const selected = this.model.users.find(x => x.id == value);
        return Promise.resolve(selected ? [selected] : []);
    }

    const lowerFilter = (filter || '').trim().toLowerCase();
    return Promise.resolve(this.model.users
        .filter(x => (x.email?.toLowerCase().includes(lowerFilter) || x.name?.toLowerCase().includes(lowerFilter)))
        .sort((a, b) => (a.email || '').localeCompare(b.email || ''))
        .slice(0, 50));
  }
}
